/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

const createFooterSectionStyles = makeStyles(theme =>
  createStyles({
    root: {
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      backgroundColor: '#F6F7F8',
      paddingBottom: '80px',
    },
    link: {
      marginBottom: '40px',
      '& > a': {
        color: theme.palette.primary.main,
        fontWeight: 400,
        letterSpacing: '0',
        lineHeight: '20px',
        textDecoration: 'none',
      },
    },
    socialContainer: {
      display: 'flex',
      alignItems: 'center',
    },
    socialLink: {
      color: theme.palette.primary.main,
      width: '24px',
      height: '24px',

      transition: 'all .2s linear',
      '&:hover': {
        opacity: '0.8',
      },
      '&:not(:last-child)': {
        marginRight: '40px',
      },
      '& > svg': {
        fontSize: '26px',
      },
    },
  }),
);

export { createFooterSectionStyles };
